import React from "react";
import RoleTypes from "./RoleTypes";
import PartyRoleTypeService from "../../../../../services/PartyRoleTypeService";
import { constants } from "../../../../../utils/Constants";
import CommonUtil from "../../../../../utils/CommonUtil";
import { paths } from "../../../../paths";
import { labels } from "../../../../../localization/labels";
import {
  activeFilter,
  inullFilter
} from "../../../../../services/FilteringUtils";
import PathUtil from "../../../../../utils/PathUtil";
import SearchableTreeComponent from "../../../page/SearchableTreeComponent/SearchableTreeComponent";

class RoleTypesContainer extends SearchableTreeComponent {
  constructor(props) {
    super(props);

    this.partyRoleTypeService = new PartyRoleTypeService();
  }

  initialPageSize() {
    return 12;
  }

  initialSortInfo() {
    return {
      orderBy: "name",
      direction: "asc"
    };
  }

  loadRoots = pageInfo => {
    pageInfo = {
      ...pageInfo,
      filters: {
        ...activeFilter,
        ...pageInfo.filters,
        parentPartyRoleTypeIdSpec: inullFilter
      }
    };

    this.prepareCall(
      this.partyRoleTypeService.getEntities(
        pageInfo,
        this.sortInfo,
        this.onRootDataLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  loadData = expanded => {
    const url = expanded._links.children.href;
    this.prepareCall(
      this.partyRoleTypeService.getEntitiesWithParams(
        url,
        this.state.pageInfo,
        this.sortInfo,
        this.onDataLoad,
        this.messageHandler.handleError
      )
    );
    return this.performCalls();
  };

  getComponentTitle = () => {
    return undefined;
  };

  checkNodeCallback = (item, data) => {
    return (
      "" + item.id ===
      CommonUtil.queryParamsGetValueForKey(
        constants.PARTY_ROLE_TYPE_PARENT_ID,
        data._links.self.href
      )
    );
  };

  loadPartyRoleTypesWithFilter = pageInfo => {
    this.prepareCall(
      this.partyRoleTypeService.getEntities(
        pageInfo,
        this.sortInfo,
        this.onLoadWithFilter,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onClick = id => {
    let dataRef;
    this.loop(this.state.content, id, (item, index, arr) => (dataRef = item));
    if (!dataRef) return;

    const itemPath = PathUtil.adminItemsPath(
      { path: paths.ROLES },
      { path: paths.DETAIL, id: dataRef.id }
    );
    this.changePath(itemPath, dataRef.name);
  };

  handleAddNew = () => {
    const itemPath = PathUtil.adminItemsPath(
      { path: paths.ROLES },
      { path: paths.DETAIL }
    );
    this.changePath(itemPath, labels.roleType);
  };

  updateParent = (child, parent) => {
    const partRoleType = {
      _links: child._links,
      parentPartyRoleType: {
        id: parent.id
      }
    };

    this.prepareCall(
      this.partyRoleTypeService.putEntity(
        partRoleType,
        this.onEmptyLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  loadEntitiesWithFilter = pageInfo => {
    this.loadPartyRoleTypesWithFilter(pageInfo);
  };

  render() {
    return (
      <RoleTypes
        {...this.renderProps()}
        draggable={true}
        handleShow={this.handleAddNew}
        onClick={this.onClick}
        activeValue={this.state.pageInfo.active}
      />
    );
  }
}

export default RoleTypesContainer;
